import { graphql, useStaticQuery } from 'gatsby';
import React from 'react';

const useTeamMembers = () => {
  const {
    allContentfulTeam: { nodes: team },
    allContentfulTimeline: { nodes: times },
  } = useStaticQuery(graphql`
    query TeamMembers {
      allContentfulTeam(sort: { fields: serial }) {
        nodes {
          id
          position
          name
          about {
            childMarkdownRemark {
              html
            }
          }
          memberType
          image {
            fluid {
              ...GatsbyContentfulFluid
            }
          }
        }
      }
      allContentfulTimeline(sort: { fields: year, order: DESC }) {
        nodes {
          id
          title
          year
          description
        }
      }
    }
  `);
  return { team, times };
};

export default useTeamMembers;
